import { Component, HostListener, ViewChild } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES, AutoResume } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { NavigationEnd, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { SwUpdate } from '@angular/service-worker';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'KawneerDirectUI';
  dialogTitle = 'Information';
  idleState = 'Not started.';
  opened = false;
  timedOut = false;
  timeOutTime = '';
  lastPing?: Date = null;
  public timeToWait: number = 1200;//in secounds
  public timeToTimeout: number = 600;//in secounds
  public countStart: number = 0;
  public subscription: Subscription;
  outageObj: any = null;
  showOutage: boolean = false;
  showUnAuth: boolean = false;
  scrHeight: any;
  scrWidth: any;
  isMobile: boolean;
  constructor(private idle: Idle, private keepalive: Keepalive, private router: Router, private userService: UserService, private update: SwUpdate) {

    //GA implementation 
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('set', 'page', event.urlAfterRedirects);
        gtag('send', 'pageview')
        //gtag('config', 'G-FYYEFR5Q27', { 'page_view': event.urlAfterRedirects });
       
      }
      
    })

    this.handleStorageListner();
    this.getScreenSize();
    if (this.isMobile) {
      this.updateAppNotification();
    }
    this.subscription = this.userService.ToggleIdleSession.subscribe(hasChange => {
      if (hasChange) {

        idle.setIdle(this.timeToWait);
        idle.setTimeout(this.timeToTimeout);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.setAutoResume(AutoResume.notIdle);

        idle.onIdleEnd.subscribe(() => {
          this.idleState = 'No longer idle.'
          localStorage.isAppActive = "0"
          this.reset();
        });

        idle.onTimeout.subscribe(() => {
          //console.log("ontimeout" + new Date());
          this.idleState = 'You are timed out due to inactivity!';
          this.timedOut = true;
          this.logout();
          this.router.navigate(['/home']);
          this.opened = true;
        });

        idle.onIdleStart.subscribe(() => {
          //log the idle start time.

          var url = this.router.url;
          if (url.includes("window-pricing") || url.includes("thermal-calculator")) {
            this.reset();
          }
          else {
            this.idleState = 'You\'ve gone idle!';
            localStorage.isAppActive = "1"
            this.timeOutTime = this.formatAMPM(this.addMinutesToDate(new Date(), (this.timeToTimeout) / 60));
            console.log(this.idleState + ' at ' + new Date());
            this.opened = true;
          }
        });

        idle.onTimeoutWarning.subscribe((countdown) => {

          if (this.checkIfOtherTabIsActive()) { this.resetIdle(); return; }
          // console.log("timeout warning" + new Date());
          //dif = strattime - current time 
          //current time log.  startimre - current time ... if < 30  then Popup(ideal since _ minutes. will be logged out in next 30 - diff minutes)
          if (this.countStart == 0) {
            this.countStart = countdown;
          }
          //console.log(countdown + " " + this.countStart)
          var t = this.timeToWait + (this.countStart - countdown);
          //var minutes = Math.floor(countdown / 60);
          //var seconds = countdown - minutes * 60;
          //this.idleState = 'You have been idle since last ' + Math.floor(t / 60) + ' minutes ' + 'You will be logged out in next ' + minutes + " minutes " + seconds + ' seconds!'

          this.idleState = 'You have been idle since last ' + Math.floor(t / 60) + ' minutes ' + 'You will be logged out at ' + this.timeOutTime + '!'
          // console.log(this.idleState + ' at ' + new Date());
        });

        // sets the ping interval to 15 seconds
        keepalive.interval(1);

        keepalive.onPing.subscribe(() => this.lastPing = new Date());
        this.reset();
      }
      else {

        this.idle.stop();
      }
    })
    this.userService.ToggleIdleSession.next(this.userService.isAuthenticated());
    this.userService.OutageObject.subscribe(getOutageObj => {
      if (getOutageObj) {
        this.outageObj = getOutageObj;
        this.showOutage = true;
      }
      else {
        this.showOutage = false;
      }
    });

    //this.userService.UnAuthReq.subscribe(unauth => {
    //  if (unauth) {
    //    this.showUnAuth = true;
    //  }
    //  else {
    //    this.showUnAuth = false;
    //  }
    //});
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Welcome Back';//'Welcome back! Select one of the following two options to continue';
    this.timedOut = false;
  }
  resetIdle() {
    this.idle.watch();
    this.timedOut = false;
  }
  closeInfoModal() {
    this.opened = false;
  }
  logout() {
    this.closeInfoModal();
    this.userService.LogoutTrigger.next(true);
    //location.reload();
  }
  continue() {
    this.opened = false;
    this.reset();
    this.userService.refresh().subscribe(response => {
      this.userService.saveToken(response.token);
    });
  }
  addMinutesToDate(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  checkIfOtherTabIsActive() {
    //logic
    //set isActive=1;
    //on idle warining start check if appActive=true then do not show message reset counter
    //on on idlestart set appactive=false
    //on idleend set appactive=false
    if (localStorage.isAppActive && localStorage.isAppActive === "1") {
      return false;
    }
    else {
      return true;
    }
  }
  handleStorageListner() {

    // Broadcast that you're opening a page.
    localStorage.openpages = Date.now();
    window.addEventListener('storage', function (e) {
      if (e.key == "openpages") {
        // Listen if anybody else is opening the same page!
        localStorage.page_available = Date.now();
      }
      if (e.key == "page_available") {
        console.log("One more page already open");
        //alert("One more page already open");
      }
    }, false);

  }
  updateAppNotification() {
    if (!this.update.isEnabled) {
      console.log("SW not Update");
      return;
    }
    this.update.available.subscribe((evt) => {
      if (confirm('update available for the app please confirm')) {
        this.update.activateUpdate().then(() => location.reload());
      }
    });
  }
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    //console.log(this.scrHeight, this.scrWidth);
    if (this.scrWidth <= 1024) {
      this.isMobile = true;
    }
    else {
      this.isMobile = false;
    }
  }
}
